<template>
    <div
        class="cz2__renderer__360"
        :class="[
            `cz2__renderer__360--${currentGroupCode ? currentGroupCode.toLowerCase() : 'none'}`,
        ]"
    >
        <button
            @click.prevent="rotatePop(90)"
            aria-label="Rotate clockwise"
            class="cz2__renderer__rotate cz2__renderer__rotate-left"
        />

        <img
            src="../assets/icons/360-icon.svg"
            alt="Rotate 360 degrees"
            class="cz2__renderer__360--icon"
        >

        <button
            @click.prevent="rotatePop(-90)"
            aria-label="Rotate counter-clockwise"
            class="cz2__renderer__rotate cz2__renderer__rotate-right"
        />
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__renderer__360 {
            height: 30px;
            width: 100px;
            border-radius: 30px;
            background-color: rgba(255, 255, 255, 0.5);

            display: flex;
            align-items: center;

            transition: bottom $transition-fast ease-out;
        }

        .cz2__renderer__rotate {
            width: 44px;
            height: 44px;

            background-image: url(../assets/icons/rotate-pop.svg);
            background-repeat: no-repeat;
            background-position: center;

            &:focus {
                outline: none;

                background-image: url(../assets/icons/rotate-pop-focus.svg);
            }
        }

        .cz2__renderer__rotate-right {
            transform: rotate(180deg);
        }

        .cz2__renderer__360--icon {
            flex: none;
            width: 35px;
            height: 20px;
        }

        .cz2__renderer__360--name {
            display: none;
        }

        @include respond-above(sm) {
            .cz2__renderer__360 {
                gap: calc(var(--layout-spacing) / 2);

                height: 35px;
                width: 125px;
            }

            .cz2__renderer__rotate {
                background-size: 40%;
            }

            .cz2__renderer__360--icon {
                width: 46px;
                height: 26px;
            }
        }

        @include respond-above(lg) {
            .cz2__renderer__360--name {
                display: flex;
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__renderer__360 {
            transform: translate(-50%, 0) scale(1.5);

            bottom: 50px;
        }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   ▗▄▄▖▗▄▄▖ ▗▄▄▄▖▗▖   ▗▖   ▗▄▄▄▖▗▖  ▗▖ ▗▄▄▖    ▗▄▄▖ ▗▄▄▄▖▗▄▄▄▖
    //  ▐▌   ▐▌ ▐▌▐▌   ▐▌   ▐▌     █  ▐▛▚▖▐▌▐▌       ▐▌ ▐▌▐▌   ▐▌
    //   ▝▀▚▖▐▛▀▘ ▐▛▀▀▘▐▌   ▐▌     █  ▐▌ ▝▜▌▐▌▝▜▌    ▐▛▀▚▖▐▛▀▀▘▐▛▀▀▘
    //  ▗▄▄▞▘▐▌   ▐▙▄▄▖▐▙▄▄▖▐▙▄▄▖▗▄█▄▖▐▌  ▐▌▝▚▄▞▘    ▐▙▄▞▘▐▙▄▄▖▐▙▄▄
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    #cz2.cz2__is-sb {
        .cz2__renderer__360 {
            background-color: transparent;
            background-image: url(../assets/images/branded/sb-final/SB-Background_360.webp);
            background-size: 100% 100%;

            margin-bottom: 12px;

            @include respond-above(md) {
                // Otherwise it gets cut off by the nav button.
                margin-bottom: 48px;
            }

            @include respond-above(lg) {
                // Otherwise it gets cut off by the frame border...
                margin-bottom: 48px;

                &.cz2__renderer__360--review {
                    // However the problem is that on the review step we need these aligned below. And there is no frame.
                    margin-bottom: 0;
                }
            }
        }
        .cz2__renderer__rotate {
            background-image: url(../assets/images/branded/sb-final/SB-Chevron_360.webp);
            background-repeat: no-repeat;
            background-position: center;
            background-size: 30% 30%;

            &:focus {
                outline: none;

                background-image: url(../assets/images/branded/sb-final/SB-Chevron_360.webp);
                background-repeat: no-repeat;
                background-position: center;
            }
        }
        .cz2__renderer__rotate-right {
            margin-top: -2px;
        }
    }

    #cz2.cz2.cz2__is-kiosk.cz2__is-sb {
        .cz2__renderer__360 {
            margin-bottom: 0;

            bottom: 75px;
        }
        .cz2__renderer__rotate {
            background-size: 30% 30%;
        }
    }

</style>

<script>
    import chevron from '../assets/icons/chevron.svg';

    export default {
        data() {
            return {
                chevronIcon: chevron,
            };
        },

        computed: {
            currentGroup() {
                return this.$store.state.customizer.currentGroup;
            },

            currentGroupCode() {
                return this.currentGroup?.code;
            },

            inspectModalShown() {
                return this.$store.state.inspectModalShown;
            },
        },

        methods: {
            handleRotationHotkeys(event) {
                if (this.inspectModalShown) {
                    return;
                }

                if (event.key === 'ArrowRight') {
                    event.preventDefault();
                    this.rotatePop(-90);
                }

                if (event.key === 'ArrowLeft') {
                    event.preventDefault();
                    this.rotatePop(90);
                }
            },

            rotatePop(degrees) {
                this.$store.dispatch('setRotation', degrees);

                this.emitter.$emit('rotation');
            },
        },

        mounted() {
            window.addEventListener('keydown', this.handleRotationHotkeys);
        },

        beforeDestroy() {
            window.removeEventListener('keydown', this.handleRotationHotkeys);
        },
    };
</script>
